<template>
  <v-app>
    <v-toolbar
      app
      dense>
      <v-toolbar-title>
        <span class="s2s_font">Sign to Sell</span>
        <!-- still working on listing name -->
        <!-- <span v-if="storeListingName" class="caption text-xs-right">{{ storeListingName }}</span> -->
        <!-- <v-layout row justify-space-between align-baseline>
          <v-flex>
          </v-flex>
        </v-layout> -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-footer>
      <v-spacer></v-spacer>
      <div class="caption lighten-5">Sign To Sell&trade; v.{{ sts_version }} by ResaleAI&trade; | &copy; {{ new Date().getFullYear() }}</div>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      fixed: false,
      title: 'Sign To Sell',
      sts_version: process.env.STS_VERSION
    }
  },
  computed: {
    ...mapGetters(['storeListingName']),
    hasRaiStore: function () {
      return !!this.$store.raiStore || !!this.$store.checkinKey
    }
  },
  name: 'App'
}
</script>

<style>
  html { overflow-y: auto; }
  .s2s_font { font-family: 'Yellowtail', cursive; padding-right: 5px;}
</style>



// WEBPACK FOOTER //
// src/App.vue